import {Model} from "@/app/Model";
import type {KeyValoreStr} from "@/app/data/DataTypes";

export class PenaleAdmin {
    public listaPenale: Array<Partial<ItemPenale>> = [];
    public listaReatoRubrica: Array<Partial<ItemReatoRubrica>> = [];
    public itemPenale: ItemPenale = new ItemPenale();
    public itemReatoRubrica: ItemReatoRubrica = new ItemReatoRubrica();
    public deleteItemReatoRubrica: ItemReatoRubrica = new ItemReatoRubrica();
    public filtriPenale: FiltriPenale = new FiltriPenale();
    public filtriReatoRubrica: FiltriReatoRubrica = new FiltriReatoRubrica();
    public insertModeReatoRubrica: boolean = false;

    public paginazionePenale_tot: number = 0;
    public paginazionePenale_start: number = 0; //numero di pagina
    public paginazionePenale_rows: number = Model.pagination_size;
    public paginazionePenale_pages: number = 0;

    public paginazioneReatoRubrica_tot: number = 0;
    public paginazioneReatoRubrica_start: number = 0; //numero di pagina
    public paginazioneReatoRubrica_rows: number = Model.pagination_size;
    public paginazioneReatoRubrica_pages: number = 0;

    static stati_sentenze: Array<{ stato: number, label: string}> = [
        { "stato": 0, "label": "Tutti"},
        { "stato": 1, "label": "Valide"},
        { "stato": 2, "label": "Non Valide"},
    ];
    static stati_sentenze_full: Array<{ stato: number, label: string}> = [
        { "stato": 0, "label": "Tutti"},
        { "stato": 1, "label": "sentenza valida"},
        { "stato": 2, "label": "assenza durata del processo"},
        { "stato": 3, "label": "assenza capi imputazioni legge"},
        { "stato": 4, "label": "presenza durata pena ma assenza pena principale"},
    ];

    static sort_fields: string[] = [
        "data_elaborazione",
        "id_doc_master",
        "assoluzione",
        "assoluzione_motivo",
        "capo_imputazione_legge",
        "id_localita",
        "data_pronuncia_sentenza",
        "durata_del_processo",
        "durata_pena",
        "giudice",
        "importo_evaso",
        "importo_risarcimento",
        "non_menzione_nel_casellario",
        "pena_principale",
        "data",
        "id_stato_sen",
        "modifica_manuale"
    ]
    static tipo_atto: Array<{ value: string, label: string }> = [
        { label:"CCX", value: "Codice Civile"},
        { label:"CPX", value: "Codice Penale"},
        { label:"DLT", value: "Decreto legislativo"},
        { label:"DPR", value: "Decreto presidente della repubblica"},
        { label:"L", value: "Legge"},
        { label:"RD", value: "Regio decreto"},
        { label:"RDL", value: "Regio decreto legge"},
    ]

    public massiveDeleteCapoImputazione_value: string = "";
    public massiveReplaceCapoImputazione_value: string = "";
    public massiveReplaceCapoImputazione_to: string = "";
}

export class ItemReatoRubrica {
   public raw?: ItemReatoRubrica;
   public id: number = 0;
   public capo_imputazione_str: string = "";
   public tip_atto: string = "";
   public rubrica?: string;
}

export class ItemPenale {
    public raw?: ItemPenale;
    public assoluzione?: string;
    public assoluzione_motivo: string[] = [];
    public capo_imputazione_legge: string[] = [];
    public id_localita?: string;
    public data_pronuncia_sentenza?: string //"2018-11-26T23:00:00.000Z;
    public durata_del_processo?: number;
    public durata_pena: number[] = [];
    public giudice: string[] = [];
    public id_doc_master: number = 0;
    public importo_evaso?: number;
    public importo_risarcimento?: number;
    public non_menzione_nel_casellario?: boolean;
    public pena_principale: string[] = [];
    public data?: string; //"2018-12-04T23:00:00.000Z";
    public id_stato_sen?: number;
    public capo_imputazione_legge_parziale: string[] = [];
    public capo_imputazione_legge_originale: string[] = [];
    public data_elaborazione?: string; // "2024-10-09T07:12:23.361Z";
    public modifica_manuale?: boolean;
}

export class FiltriPenale {
    public id_doc_master: string = ""; // -> number  =
    public assoluzione: string = ""; //=
    public capo_imputazione_legge: string = ""; //contains
    public id_stato_sen: number = 0; //  =1 oppure > 1
    public modifica_manuale: string = ""; // -> boolean

    public data_pronuncia_sentenza: string = ""; //"2018-11-26T23:00:00.000Z; //between oppure > di e < di per ora no

    public sort_field: string = "data_elaborazione";
    public sort_order: string = "DESC";
}

export class FiltriReatoRubrica {
    public capo_imputazione_str: string = ""; //like
    public tip_atto: string = ""; //like
    public rubrica: string = ""; //like

    public sort_field: string = "capo_imputazione_str";
    public sort_order: string = "DESC";
}